export const MAX_ROWS = 9;
export const MAX_COLS = 9;
export const MAX_MINES = 10;
